module.exports = __webpack_public_path__ + "img/boflogo.6a88bbb7.png";